import * as Yup from "yup";

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-=\[\]{};':"\\|,.<>\/?])(?!.*\s).{8,}$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email must be a valid email")
    .required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must be at most 20 characters")
    .matches(
      passwordRegex,
      "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special case character"
    ),
});

export const verifyOtpSchema = Yup.object().shape({
  otp: Yup.string()
    .required("OTP is required")
    .length(6, "OTP must be at 6 characters"),
});

export const emailSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required"),
});

export const resetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be 8 characters or more")
    .required("Password is required!")
    .matches(
      passwordRegex,
      "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special case character"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords do not match")
    .required("Please confirm your password"),
});

export const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .min(8, "Password must be 8 characters or more")
    .required("Password is required!")
    .matches(
      passwordRegex,
      "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special case character"
    ),
  password: Yup.string()
    .min(8, "Password must be 8 characters or more")
    .required("Password is required!")
    .matches(
      passwordRegex,
      "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special case character"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords do not match")
    .required("Please confirm your password"),
});

export const createUserSchema = Yup.object().shape({
  first_name: Yup.string().required("First Name is required!"),
  last_name: Yup.string().required("Last Name is required!"),
  username: Yup.string().required("Username is required!"),
  phone: Yup.string()
    .min(11, "Phone must be at least 11 numbers long")
    .required("Phone Number is required!"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must be at most 20 characters")
    .matches(
      passwordRegex,
      "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special case character"
    ),
  referral_code: Yup.string(),
  source: Yup.string().required("How You Heard is required!"),
});

export const withdrawSchema = Yup.object().shape({
  amount: Yup.string().required("Amount is required"),
});

export const depositSchema = Yup.object().shape({
  amount: Yup.string().required("Amount is required"),
});

export const savingSchema = Yup.object().shape({
  amount: Yup.string().required("Amount is required"),
  frequency: Yup.string().required("Frequency is required"),
  maturity_date: Yup.mixed().required("Maturity date is required"),
  start_date: Yup.mixed().required("Start date is required"),
  is_auto_save: Yup.bool().required("Deposit mode is required"),
});

export const bvnVerificationSchma = Yup.object().shape({
  bvn: Yup.string().required("BVN is required"),
  date_of_birth: Yup.string().required("Date of birth is required"),
  gender: Yup.string().required("Gender is required"),
});

export const aboutFormSchema = Yup.object().shape({
  relationship_status: Yup.string().required("Relationship status is required"),
  employment_status: Yup.string().required("Employment status is required"),
  income_level: Yup.string().required("Income level is required"),
});

export const withdrawalAccountSchema = Yup.object().shape({
  bank: Yup.object().required("Bank is required"),
  accountNumber: Yup.string().required("Account number is required"),
});

export const studentAccountSchema = Yup.object().shape({
  first_name: Yup.string().required("First Name is required!"),
  last_name: Yup.string().required("Last Name is required!"),
  username: Yup.string().required("Username is required!"),
  phone: Yup.string()
    .min(11, "Phone must be at least 11 numbers long")
    .required("Phone Number is required!"),
  email: Yup.string()
    .email("Email must be a valid email")
    .required("Email is required"),
  referral_code: Yup.string(),
  source: Yup.string().required("How You Heard is required!"),
});

export const verifyAccountSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be 8 characters or more")
    .required("Password is required!")
    .matches(
      passwordRegex,
      "Password must contain at least 8 characters, one uppercase, one lowercase, one number, and one special character"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required!"),
});

export const addressSchema = Yup.object().shape({
  exact: Yup.string().required("Address is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
});

export const contactSupportSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email must be a valid email")
    .required("Email is required"),
  full_name: Yup.string().required("Full name is required"),
  message: Yup.string().required("Message is required"),
});
